import { render, staticRenderFns } from "./Hilfreiches.vue?vue&type=template&id=5c9489f4&scoped=true&"
import script from "./Hilfreiches.vue?vue&type=script&lang=js&"
export * from "./Hilfreiches.vue?vue&type=script&lang=js&"
import style0 from "./Hilfreiches.vue?vue&type=style&index=0&id=5c9489f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9489f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VMain,VRow})
